module.exports = __webpack_public_path__ + "static/hackeando-3acf82b0344b57ea98d7a6178e066c85.png";